import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

import Layout from '@/layout'

export const constantRoutes = [
	{
		path: '/',// 首页
		component: Layout,
		redirect: '/home',// 首页
		children: [{
			path: '/home',
			component: () => import('@/views/home.vue'),
			meta: { keepAlive: true } // 列表页需要缓存
		}]
	},{
		path: '/home-1.0',
		component: Layout,
		redirect: '/home-1.0',
		children: [{
			path: '/home-1.0',
			component: () => import('@/views/home-1.0.vue'),
		}]
	}, {
		path: '*',
		meta: {
			title: 'NotFound',
		},
		component: () => import( /* webpackChunkName: "NotFound" */ '@/views/404.vue'),
	},
	{
		path: '/product-list',// 产品列表
		component: Layout,
		redirect: '/product-list',
		children: [{
			path: '/product-list',
			component: () => import('@/views/product/product-list.vue'),
			meta: { keepAlive: true } // 列表页需要缓存
		}]
	},
	{
		path: '/product-details',// 产品详情
		component: Layout,
		redirect: '/product-details',
		children: [{
			path: '/product-details',
			component: () => import('@/views/product/product-details.vue'),
			meta: { keepAlive: false } // 详情页不缓存
		}]
	},
	{
		path: '/login',// 登录
		component: Layout,
		redirect: '/login',
		children: [{
			path: '/login',
			component: () => import('@/views/login/login.vue'),
		}]
	},
	{
		path: '/personalCenter',// 供应商认证
		component: Layout,
		redirect: '/personalCenter',
		children: [{
			path: '/personalCenter',
			component: () => import('@/views/login/personalCenter.vue'),
		}]
	},
	{
		path: '/personalCenter2',// 采购商认证
		component: Layout,
		redirect: '/personalCenter2',
		children: [{
			path: '/personalCenter2',
			component: () => import('@/views/login/personalCenter2.vue'),
		}]
	},
	{
		path: '/collect-list',// 收藏列表
		component: Layout,
		redirect: '/collect-list',
		children: [{
			path: '/collect-list',
			component: () => import('@/views/me/collect-list.vue'),
		}]
	},
	{
		path: '/shop-list',// 未提交购物车
		component: Layout,
		redirect: '/shop-list',
		children: [{
			path: '/shop-list',
			component: () => import('@/views/me/shop-list.vue'),
		}]
	},
	{
		path: '/submit-list',// 已提交购物车
		component: Layout,
		redirect: '/submit-list',
		children: [{
			path: '/submit-list',
			component: () => import('@/views/me/submit-list.vue'),
		}]
	},
	{
		path: '/submit-detail',// 已提交购物车
		component: Layout,
		redirect: '/submit-detail',
		children: [{
			path: '/submit-detail',
			component: () => import('@/views/me/submit-detail.vue'),
		}]
	},
	{
		path: '/order-list',// 订单列表
		component: Layout,
		redirect: '/order-list',
		children: [{
			path: '/order-list',
			component: () => import('@/views/me/order-list.vue'),
		}]
	},
	{
		path: '/message-list',// 消息列表
		component: Layout,
		redirect: '/message-list',
		children: [{
			path: '/message-list',
			component: () => import('@/views/me/message-list.vue'),
		}]
	},
	{
		path: '/demand-list',// 需求列表
		component: Layout,
		redirect: '/demand-list',
		children: [{
			path: '/demand-list',
			component: () => import('@/views/me/demand-list.vue'),
		}]
	},
	{
		path: '/solution',// 解决方案无人机
		component: Layout,
		redirect: '/solution',
		children: [{
			path: '/solution',
			component: () => import('@/views/solution/solution.vue'),
		},{
			path: '/solution2',
			component: () => import('@/views/solution/solution1.vue'),
		},{
			path: '/solution3',
			component: () => import('@/views/solution/solution2.vue'),
		},{
			path: '/solution4',
			component: () => import('@/views/solution/solution3.vue'),
		}
		]
	},
	{
		path: '/solution-details',// 解决方案详情
		component: Layout,
		redirect: '/solution-details',
		children: [{
			path: '/solution-details',
			component: () => import('@/views/solution/solution-details.vue'),
		}]
	},
	{
		path: '/purchase-list',// 采购大厅
		component: Layout,
		redirect: '/purchase-list',
		children: [{
			path: '/purchase-list',
			component: () => import('@/views/purchase/purchase-list.vue'),
		}]
	},
	{
		path: '/purchase-details',// 采购详情
		component: Layout,
		redirect: '/purchase-details',
		children: [{
			path: '/purchase-details',
			component: () => import('@/views/purchase/purchase-details.vue'),
		}]
	},
	{
		path: '/news-list',// 新闻中心
		component: Layout,
		redirect: '/news-list',
		children: [{
			path: '/news-list',
			component: () => import('@/views/news/news-list.vue'),
		}]
	},
	{
		path: '/news-details',// 新闻详情
		component: Layout,
		redirect: '/news-details',
		children: [{
			path: '/news-details',
			component: () => import('@/views/news/news-details.vue'),
		}]
	},
	{
		path: '/ContactUs',// 联系我们
		component: Layout,
		redirect: '/ContactUs',
		children: [{
			path: '/ContactUs',
			component: () => import('@/views/news/ContactUs.vue'),
		}]
	},
	{
		path: '/reservation',// 预约
		component: Layout,
		redirect: '/reservation',
		children: [{
			path: '/reservation',
			component: () => import('@/views/news/reservation.vue'),
		}]
	},
	{
		path: '/news-texts',// 新闻详情
		component: Layout,
		redirect: '/news-texts',
		children: [{
			path: '/news-texts',
			component: () => import('@/views/news/news-texts.vue'),
		}]
	},
	{
		path: '/about',// 关于我们0
		component: Layout,
		redirect: '/about',
		children: [{
			path: '/about',
			component: () => import('@/views/news/about.vue'),
		}]
	},
	{
		path: '/about1',// 关于我们1
		component: Layout,
		redirect: '/about1',
		children: [{
			path: '/about1',
			component: () => import('@/views/children/about1.vue'),
		}]
	},
	{
		path: '/about3',// 关于我们2
		component: Layout,
		redirect: '/about3',
		children: [{
			path: '/about3',
			component: () => import('@/views/children/about3.vue'),
		}]
	},
	{
		path: '/about3-1',// 关于我们2
		component: Layout,
		redirect: '/about3-1',
		children: [{
			path: '/about3-1',
			component: () => import('@/views/children/about3-1.vue'),
		}]
	},
	{
		path: '/me',// 个人中心
		component: Layout,
		redirect: '/me',
		children: [{
			path: '/me',
			component: () => import('@/views/me/me.vue'),
		}]
	},
]
const router = new VueRouter({
	mode: 'history',
	routes: constantRoutes,
	//增加这个配置
	scrollBehavior(to, from, savedPosition) {
		if(savedPosition) {
			return savedPosition
		} else {
			return {
				x: 0,
				y: 0
			}
		}
	}
})

router.beforeEach((to, from, next) => {
	document.title = 'King Hang'
	next()
})

export default router
